
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, signal } from '@angular/core';
import { EstablishmentFavoritesService } from './service/establishment-favorites.service';
import { EstablishemntsGeneralComponent } from "../../../establishemnts-general/establishemnts-general.component";
import { EstablishmentsForCategorieData, EstablishmentsForCategorieResponse } from '../../../establishments-for-categorie/interface/establishments-for-categorie.interface';
import { BehaviorSubject, Subject, switchMap, takeUntil } from 'rxjs';
import { CreateSlugService } from '../../../../core/service/create-slug.service';
import { Router } from '@angular/router';
import { AppState } from '../../../../store/app.state';
import { Store } from '@ngrx/store';

@Component({
  selector: 'perfil-establishment-favorites',
  imports: [EstablishemntsGeneralComponent],
  templateUrl: `./establishment-favorites.component.html`,
  styleUrl: './establishment-favorites.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EstablishmentFavoritesComponent implements OnInit {
  isLoading: boolean = true;
  establishments = signal<EstablishmentsForCategorieData[]>([]);
  private destroy$ = new Subject<void>();
  private loading = new BehaviorSubject<boolean>(false);
  constructor(private establishmentFavoritesService: EstablishmentFavoritesService,
    private createSlugService: CreateSlugService,
    private cdr: ChangeDetectorRef,
    private store: Store<AppState>,
    private router: Router,

  ) {

  }

  ngOnInit(): void {
    this.loadEstablishmentsFavorites();
  }


  ngDoCheck(): void {
    this.establishments();
    this.cdr.detectChanges();
  }

loadEstablishmentsFavorites(): void {
  this.store.select(state => state.location).pipe(
    takeUntil(this.destroy$),
    switchMap(location => {
      this.isLoading = true;
      this.cdr.detectChanges();
      return this.establishmentFavoritesService.getFavoritesEstablishments(
           location.latitude.toString(),
        location.longitude.toString()
      );
    })
  ).subscribe({
    next: (response: EstablishmentsForCategorieResponse) => {
      this.establishments.set(response.data);
      this.isLoading = false;
      this.cdr.markForCheck();
    },
    error: (error) => {
      console.error('Error al obtener favoritos:', error);
      this.isLoading = false;
      this.cdr.markForCheck();
    }
  });
}

  private createSlug(text: string): string {
    if (!text) return '';
    return this.createSlugService.createSlug(text);
  }


  async navigateToProducts(event: { id_restaurant: number, name_restaurant: string }): Promise<void> {
    try {
      this.loading.next(true);
      const slug = this.createSlug(event.name_restaurant);
      await this.router.navigate(['/products-establishment', event.id_restaurant, slug]);
    } catch (error) {
      console.error('Error al navegar a productos:', error);
      // Intento de fallback a la ruta sin slug si falla
      try {
        await this.router.navigate(['/products-establishment', event.id_restaurant]);
      } catch {
        console.error('Falló también la navegación de fallback');
      }
    } finally {
      this.loading.next(false);
      this.cdr.markForCheck();
    }
  }
}
